import { render, staticRenderFns } from "./BasicsCardTips.vue?vue&type=template&id=5c83f789"
import script from "./BasicsCardTips.vue?vue&type=script&lang=js"
export * from "./BasicsCardTips.vue?vue&type=script&lang=js"
import style0 from "./BasicsCardTips.vue?vue&type=style&index=0&id=5c83f789&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports